module.exports = __webpack_public_path__ + "img/layers-blue.782dcbb8.svg";